import { CSSProperties } from "react";

/* ── System design tokens (from mui-themes.ts) ── */
export const palette = {
  background: { default: "#F8F9FD", paper: "#fff" },
  divider: "#E5E8EF"
} as const;

const shadow = {
  xl: "0px 10px 10px -5px rgba(18, 18, 23, 0.04), 0px 20px 25px -5px rgba(18, 18, 23, 0.10)"
} as const;

export const border = (c: string = palette.divider) => `1px solid ${c}`;

/* ── Shared layout styles (used as sx values) ── */
export const s = {
  /* Overlay / modal */
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 1300,
    background: "rgba(37, 45, 57, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24
  } satisfies CSSProperties,

  modal: {
    width: "100%",
    maxWidth: 1100,
    maxHeight: "calc(100vh - 48px)",
    background: palette.background.paper,
    borderRadius: 12,
    border: border(),
    boxShadow: shadow.xl,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    outline: "none"
  } satisfies CSSProperties,

  /* Scrollable content area — minHeight:0 lets the flex child shrink so the
     inner list scrolls instead of pushing the footer out of the modal. */
  contentArea: {
    minHeight: 0,
    overflowY: "auto",
    flex: 1,
    background: palette.background.paper
  } satisfies CSSProperties,

  /* Row styles — shared across tree/list views.
     Not typed `satisfies CSSProperties` because they carry a `&:hover` selector. */
  folderRow: {
    borderBottom: border(),
    cursor: "pointer",
    userSelect: "none",
    transition: "background 0.1s",
    "&:hover": { background: palette.background.default }
  },

  fileRow: {
    borderBottom: border(),
    transition: "background 0.1s",
    cursor: "pointer",
    "&:hover": { background: palette.background.default }
  },

  fileRowSelected: {
    borderBottom: border(),
    transition: "background 0.1s",
    cursor: "pointer",
    background: "#ecf1f9",
    "&:hover": { background: "#F8F9FD" }
  },

  /* Hidden file input */
  hiddenInput: {
    width: 0,
    height: 0,
    position: "absolute",
    overflow: "hidden",
    opacity: 0
  } satisfies CSSProperties
} as const;

/* ── Column widths for picker table ── */
export const templateColumns = {
  checkbox: { width: 32, flexShrink: 0 },
  name: { width: 380, flexShrink: 0 },
  classification: { flex: 1, minWidth: 0 },
  investor: { flex: 1, minWidth: 0 },
  effectiveDate: { flex: 1, minWidth: 0 },
  uploadDate: { flex: 1, minWidth: 0 }
} as const;

export const cellPx = { pl: "16px", pr: "10px" } as const;
